"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/hamburg/style"));
var _default = _ref => {
  let {
    className,
    onClickEvent
  } = _ref;
  return _react.default.createElement(_style.default, {
    role: "button",
    className: className || '',
    onClick: () => onClickEvent(true)
  }, _react.default.createElement("div", null), _react.default.createElement("div", null), _react.default.createElement("div", null));
};
exports.default = _default;